export default __webpack_public_path__ + "static/informacion-98d3060e23ba9f3a48fc469d3dd89e67.png";